import { useQueries } from "@tanstack/react-query";
import { epicPullRequests } from "./model";
import type { BoardItem } from "./model";
import { prEvidenceQuery } from "./prEvidence";

export function EpicDeliveryStatus({ items }: { items: BoardItem[] }) {
  const links = epicPullRequests(items);
  const queries = useQueries({ queries: links.map(prEvidenceQuery) });
  if (!links.length) return <div className="board-note">Merge & builds: no linked PRs</div>;
  const current = queries.flatMap(q => !q.isError && q.data ? [q.data] : []);
  const merged = current.filter(p => !p.prError && p.state === "completed").length;
  const open = current.filter(p => !p.prError && p.state === "active").length;
  const abandoned = current.filter(p => !p.prError && p.state === "abandoned").length;
  const builds = current.filter(p => !p.pipelineError).flatMap(p => p.pipelines.filter(b => b.currentRevision === true));
  const failed = builds.filter(b => b.result === "failed").length;
  const running = builds.filter(b => b.status === "inProgress" || b.status === "notStarted").length;
  const passed = builds.filter(b => b.status === "completed" && b.result === "succeeded").length;
  const incomplete = queries.some(q => q.isError || !q.data)
    || current.some(p => p.prError || p.pipelineError || !p.pipelines.length || p.pipelines.some(b => b.currentRevision !== true));
  return <div className="board-card-delivery" aria-label="Epic merge and build status">
    <div><strong>Merge</strong> · {merged}/{links.length} PRs merged · {open} open{abandoned > 0 ? ` · ${abandoned} abandoned` : ""}</div>
    <div className={failed ? "board-risk" : ""}><strong>PR builds</strong> · {passed}/{builds.length} current checks passed{failed ? ` · ${failed} failed` : ""}{running ? ` · ${running} queued/running` : ""}</div>
    {incomplete && <div className="board-note">Some evidence is loading, unavailable or from an earlier revision.</div>}
    <div className="board-note">Linked PR validation · refreshes every minute</div>
  </div>;
}
